import React from "react";
import "../styling/MunicipalityText.css";

const Malmö = () => {
  return (
    <div className="outer-wrapper">
      <div className="content-wrapper">
        <h2 className="content-title">Lediga lokaler i Malmö</h2>
        <p className="content-text">
          Malmö är Öresundsregionens pulserande knutpunkt – med närhet till
          Köpenhamn/Kastrup via Öresundsbron, starka kluster inom logistik,
          e-handel, spel/tech, livsmedel och kreativa näringar, samt god
          tillgång till kompetens från Malmö universitet. På Vakansa hittar du
          kontor, kontorshotell/coworking, butik/showroom, lager/logistik och
          produktionslokaler. Vi hjälper dig att filtrera fram rätt alternativ
          och boka visning – snabbt och smidigt.
        </p>
        <h3>Varför hyra lokal i Malmö?</h3>
        <ul className="content-ol">
          <li>
            <b>Läge & räckvidd:</b> 20–30 min till Kastrup/Köpenhamn, E6/E20/E22
            och god tågförbindelse via Citytunneln.
          </li>
          <li>
            <b>Tillgång på talang:</b> Växande tech-ekosystem, stark
            spel-/designscen och internationell arbetsmarknad.
          </li>
          <li>
            <b>Korta avstånd:</b> Kompakt stad med närhet mellan innerstad, hamn
            och logistiklägen.
          </li>
          <li>
            <b>Flexibilitet:</b> Från flexplatser i coworking till stora lager
            och moderna kontor – skala upp utan att byta stad.
          </li>
        </ul>
        <h3>Populära områden</h3>
        <ul>
          <li>
            <b>Centrum/Innerstaden:</b> Representativa kontor nära Malmö C,
            restauranger och service.
          </li>
          <li>
            <b>Västra Hamnen:</b> Moderna kontor, hållbar stadsutveckling och
            vattennära lägen.
          </li>
          <li>
            <b>Hyllie:</b> Knutpunkt mot Danmark/Kastrup; kontor, handel och
            evenemang – starkt pendlingsläge.
          </li>
          <li>
            <b>Triangeln/Möllevången/Södra Innerstaden:</b> Kreativa
            verksamheter, studios, butiker och smarta kontorslösningar.
          </li>
          <li>
            <b>Limhamn/Bunkeflo:</b> Showroom, lätt industri och närhet till
            ringvägar.
          </li>
          <li>
            <b>Fosie/Jägersro:</b> Lager/logistik, produktion och grossist –
            lätt att nå med bil och lastmiljöer.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Malmö;
